/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load GA4 premium functions
 * */

(function (wpm, $, undefined) {

}(window.wpm = window.wpm || {}, jQuery))
